import styled from 'styled-components';
import { spacing, typography } from '~/theme';
import colors from '~/theme/variables/colors';
import ChevronDown from '~/assets/icons/ontario-icon-chevron-down.svg';
import ChevronUp from '~/assets/icons/ontario-icon-chevron-up.svg';
import breakpoints from '~/theme/variables/breakpoints';

export const AccordionItem = styled.div`
    min-height: 58px;
    border-top: 2px solid ${colors.modalBorder};
`;

export const AccordionTitle = styled.div`
    display: flex;
    align-items: center;
    &:hover {
        cursor: pointer;
    }

    h3 {
        margin: ${spacing.spacing0};
        max-width: 100%;
    }
`;

export const AccordionButton = styled.button`
    display: flex;
    align-items: center;
    margin-bottom: ${spacing.spacing0};
    padding: ${spacing.spacing3} ${spacing.spacing2};
    width: 100%;
    color: ${colors.baseLink};
    text-align: left;
    background: 0 0;
    border: 0;
    box-sizing: border-box;
    cursor: pointer;
    font-size: ${typography.fontSizeLarge}px;
    font-weight: ${typography.fontWeightBold};
    letter-spacing: ${typography.letterSpacingMedium};
    line-height: ${typography.lineHeight17};

    @media (${breakpoints.medium}) {
        font-size: ${typography.fontSizeExtraLarge}px;
        letter-spacing: ${typography.letterSpacingLarge};
        line-height: ${typography.lineHeight17};
    }

    &:focus,
    &:hover {
        background-color: ${colors.palette.greyscale5};
        color: ${colors.palette.systemMidBlue};
    }

    &:focus {
        outline: 4px solid transparent;
        box-shadow: 0 0 0 4px ${colors.palette.systemFocusBlue} inset;
        transition: box-shadow 0.1s ease-in-out;
    }

    & .ontario-icon {
        width: 1.75rem;
        height: 1.75rem;
    }
`;

export const AccordionContainer = styled.div`
    & .accordion:last-child {
        border-bottom: 2px solid ${colors.modalBorder};
    }
`;

export const AccordionContentContainer = styled.div`
    padding: ${spacing.spacing3} ${spacing.spacing3} ${spacing.spacing6} ${spacing.spacing3};

    @media (${breakpoints.medium}) {
        padding: ${spacing.spacing3} ${spacing.spacing3} ${spacing.spacing3} ${spacing.spacing7};
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    margin: ${spacing.spacing2};
`;

export const ExpandButton = styled.button`
    background: transparent;
    border: none;
    color: ${colors.baseLink};
    font-size: 1rem;
    text-align: left;
    padding: ${spacing.spacing0};

    &:hover {
        border-bottom: 2px solid ${colors.baseLink};
        margin-bottom: -2px;
        cursor: pointer;
        padding: ${spacing.spacing0};
    }

    &: focus,
    &:active {
        box-shadow: 0 0 0 4px ${colors.palette.systemFocusBlue};
        outline: 4px solid transparent;
        transition: box-shadow 0.1s ease-in-out;
    }
`;

export const StyledChevronUp = styled(ChevronUp)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.baseLink};
    }
`;
export const StyledChevronDown = styled(ChevronDown)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.baseLink};
    }
`;
